<template>
  <BModal
    :id="id"
    hide-header
    hide-footer
    centered
    content-class="rounded-lg"
  >
    <div class="text-center mb-2">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Konfirmasi"
        class="mx-auto my-2"
        width="80px"
      >
      <h1 class="font-semibold text-[18px] text-[#333333] mb-2">
        {{ itemId ? 'Simpan Perubahan?' : 'Tambahkan ID BM?' }}
      </h1>
      <p>
        Apakah kamu yakin ingin {{ itemId ? 'memperbarui' : 'menambahkan' }} data Business Manager ini? Pastikan data sudah sesuai.
      </p>
    </div>
    <div class="flex flex-row gap-6 mb-1">
      <BButton
        variant="outline-primary"
        class="flex-grow"
        :disabled="isLoadingSubmit"
        @click="$emit('close')"
      >
        Batal
      </BButton>
      <BButton
        variant="primary"
        class="flex-grow"
        :disabled="isLoadingSubmit"
        @click="onSubmit"
      >
        <b-spinner
          v-if="isLoadingSubmit"
          small
        />
        <span class="ms-[.5rem]">Ya, {{ itemId ? 'Simpan Perubahan' : 'Tambahkan' }}</span>
      </BButton>
    </div>
  </BModal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    itemId: {
      type: [Number, null],
      default: null,
    },
    form: {
      type: Object || null,
      default: null,
    },
  },
  data() {
    return {
      isLoadingSubmit: false,
    }
  },
  methods: {
    async onSubmit() {
      this.isLoadingSubmit = true
      if (this.itemId) {
        await this.updateBusinessManager(this.itemId)
      } else {
        await this.storeBusinessManager()
      }
      this.isLoadingSubmit = false
      this.$emit('close')
    },
    async storeBusinessManager() {
      const payload = {
        bm_name: this.form.bm_name,
        bm_id: this.form.bm_id,
        platform: this.form.platform,
        account_limit: Number(this.form.account_limit),
      }

      const url = 'komads/api/v1/admin/system_bm/store'

      await newAxiosIns
        .post(url, payload)
        .then(() => {
          this.$toast_success({ title: 'Berhasil', message: 'Data Business Manager berhasil ditambahkan' })
          this.$emit('success')
        })
        .catch(() => {
          this.$toast_error({ title: 'Gagal', message: 'Data Business Manager gagal ditambahkan' })
        })
    },
    async updateBusinessManager(itemId) {
      const payload = {
        bm_name: this.form.bm_name,
        account_limit: Number(this.form.account_limit),
      }

      const url = `komads/api/v1/admin/system_bm/${itemId}/update`

      await newAxiosIns
        .put(url, payload)
        .then(() => {
          this.$toast_success({ title: 'Berhasil', message: 'Data Business Manager berhasil diperbarui' })
          this.$emit('success')
        })
        .catch(() => {
          this.$toast_error({ title: 'Gagal', message: 'Data Business Manager gagal diperbarui' })
        })
    },
  },
}
</script>
